import React from 'react';
import { Navigate, generatePath, useLocation, useParams } from 'react-router-dom';

/**
 * LegacyRedirect — replaces an old URL with its new home, keeping the
 * visitor's query string and hash. `to` is a route pattern filled from the
 * current params (e.g. "/projects/:id"); `set` overrides query keys.
 *
 *   <Route path="/projects/:id/ai" element={<LegacyRedirect to="/projects/:id" set={{ tab: 'Tools', view: 'ai' }} />} />
 */
export function LegacyRedirect({ to, set = {} }: { to: string; set?: Record<string, string> }) {
    const params = useParams();
    const { search, hash } = useLocation();
    const query = new URLSearchParams(search);
    for (const [k, v] of Object.entries(set)) query.set(k, v);
    const qs = query.toString();
    return <Navigate replace to={`${generatePath(to, params)}${qs ? `?${qs}` : ''}${hash}`} />;
}
